import { render } from "./CarouselBanner.vue?vue&type=template&id=681a34d6&scoped=true&ts=true"
import script from "./CarouselBanner.vue?vue&type=script&lang=ts"
export * from "./CarouselBanner.vue?vue&type=script&lang=ts"

import "./CarouselBanner.vue?vue&type=style&index=0&id=681a34d6&lang=scss"
import "./CarouselBanner.vue?vue&type=style&index=1&id=681a34d6&lang=scss&scoped=true"

import exportComponent from "E:\\agent\\azdo\\CI\\a1-CI\\_work\\98\\s\\src\\MagnetoEnergy.Vue.WebClient\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-681a34d6"]])

export default __exports__